"use client";
import { useEffect } from "react";
import DrawerSection from "@/components/DrawerSection";
import DrawerSectionDesktop from "@/components/DrawerSectionDesktop";
import ImgsHeroSection from "@/components/ImgsHeroSection";
import { useNavbarColor } from "@/context/NavbarColorContext";

export default function DiningPage({
  diningPageData,
  locale,
}: {
  diningPageData: any;
  locale: string;
}) {
  const pageData = diningPageData;
  const { setIsWhite } = useNavbarColor();

  useEffect(() => {
    setIsWhite(false);
  }, [setIsWhite]);

  return (
    <>
      {pageData && (
        <ImgsHeroSection
          title={pageData.SectionOne.Title}
          text={pageData.SectionOne.Description}
          imgs={pageData.SectionOne.Images.data}
        />
      )}

      <div className="relative mt-96 hidden min-h-screen flex-col lg:flex">
        {pageData.SectionTwo.map((section: any, i: number) => (
          <div key={i} className="mb-20">
            <DrawerSectionDesktop
              mainTitle={section.MainTitle}
              title={section.Title}
              text={section.Description}
              time={section.Details}
              img={section.MainImage.data.attributes}
              slidesTitle={section.FeaturesTitle}
              slides={section.FeaturesData}
              logo={section?.Logo?.data?.attributes}
            />
          </div>
        ))}
      </div>

      <div className="relative mt-96 flex min-h-screen flex-col lg:hidden">
        {pageData.SectionTwo.map((section: any, i: number) => (
          <div key={i} className="mb-20">
            <DrawerSection
              mainTitle={section.MainTitle}
              title={section.Title}
              text={section.Description}
              time={section.Details}
              img={section.MainImage.data.attributes}
              slidesTitle={section.FeaturesTitle}
              slides={section.FeaturesData}
              logo={section?.Logo?.data?.attributes}
            />
          </div>
        ))}
      </div>
    </>
  );
}
